var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.getLoadingStatus),expression:"getLoadingStatus"}],attrs:{"id":"loading-bar"}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"lds-ring"},[_c('div'),_c('div'),_c('div'),_c('div'),_c('p',{staticClass:"loading-msg"},[_vm._v("Chargement des données...")])])
}]

export { render, staticRenderFns }